import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ThemeModeService } from '@core/services/theme-mode.service'

@Component({
  selector: 'component-logo-box',
  imports: [RouterLink, CommonModule],
  template: `
    <a routerLink="/" class="navbar-brand pe-3">
      <img
        [src]="
          (isDarkMode$ | async)
            ? 'assets/img/logo-full-white.png'
            : 'assets/img/logo-full-black.png'
        "
        width="140px"
        alt="Logo"
      />
    </a>
  `,
})
export class LogoBoxComponent {
  isDarkMode$ = this.themeModeService.isDarkMode$

  constructor(private themeModeService: ThemeModeService) {}
}
